<ng-content></ng-content>
@if (canDelete) {
  <i class="fa-regular fa-xmark soft-chip-icon" (click)="delete.emit()"> </i>
}
